import React from "react";

import KPIDashboard from "~/pages/purchase-orders/components/sales-notes/KPIDashboard";
import SalesChart from "~/pages/purchase-orders/components/sales-notes/SalesChart";
import SalesNotesSummary from "~/pages/purchase-orders/components/sales-notes/SalesNotesSummary";
import StatusDistributionChart from "~/pages/purchase-orders/components/sales-notes/StatusDistributionChart";
import {
  SalesData,
  StatusDistribution,
  TimePeriod,
  ViewMode,
} from "~/pages/purchase-orders/types/sales-notes";
import { SalesRequest } from "~/types/client";

interface DashboardViewProps {
  displayedOrders: SalesRequest[];
  totalOrders: number;
  totalAmount: number;
  pendingAmount: number;
  approvalRate: number;
  salesData: SalesData[];
  statusDistribution: StatusDistribution[];
  timePeriod: TimePeriod;
  handleTimePeriodChange: (period: TimePeriod) => void;
  clientNames: Record<string, string>;
  getSellerInfo: (sellerId: string) => {
    name: string;
    lastname: string;
    email: string;
  };
  handleOrderClick: (order: SalesRequest) => void;
  isSeller: boolean;
  setViewMode: (mode: ViewMode) => void;
  getEmptyStateMessage: () => string;
}

export const DashboardView: React.FC<DashboardViewProps> = ({
  displayedOrders,
  totalOrders,
  totalAmount,
  pendingAmount,
  approvalRate,
  salesData,
  statusDistribution,
  timePeriod,
  handleTimePeriodChange,
  clientNames,
  getSellerInfo,
  handleOrderClick,
  isSeller,
  setViewMode,
  getEmptyStateMessage,
}) => {
  return (
    <>
      {/* KPI Dashboard Cards */}
      <KPIDashboard
        totalOrders={totalOrders}
        totalAmount={totalAmount}
        pendingAmount={pendingAmount}
        approvalRate={approvalRate}
        displayedOrders={displayedOrders}
      />

      {/* Charts Row */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {/* Sales Evolution Chart */}
        <SalesChart
          salesData={salesData}
          timePeriod={timePeriod}
          handleTimePeriodChange={handleTimePeriodChange}
        />

        {/* Status Distribution Pie Chart */}
        <StatusDistributionChart statusDistribution={statusDistribution} />
      </div>

      {/* Sales Notes Table in Dashboard View */}
      <SalesNotesSummary
        displayedOrders={displayedOrders}
        clientNames={clientNames}
        getSellerInfo={getSellerInfo}
        handleOrderClick={handleOrderClick}
        isSeller={isSeller}
        setViewMode={setViewMode}
        getEmptyStateMessage={getEmptyStateMessage}
      />
    </>
  );
};

export default DashboardView;
